import { render, staticRenderFns } from "./AboutButton.vue?vue&type=template&id=5954acde"
import script from "./AboutButton.vue?vue&type=script&lang=ts"
export * from "./AboutButton.vue?vue&type=script&lang=ts"
import style0 from "./AboutButton.vue?vue&type=style&index=0&id=5954acde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports